/** HTML 转义，防止注入到 innerHTML 时产生 XSS */
export function escapeHtml(value) {
  const element = document.createElement('div');
  element.textContent = String(value ?? '');
  return element.innerHTML;
}
